// extracted by mini-css-extract-plugin
export default {"container":"Arrow_container__bvSCi","arrow":"Arrow_arrow__Uf6Xk","arrowMove":"Arrow_arrowMove__z52Lg","arrow1":"Arrow_arrow1__QvNrY","arrow2":"Arrow_arrow2__KH5Ln"};